/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAccountBalance } from '../fn/payments/get-account-balance';
import { GetAccountBalance$Params } from '../fn/payments/get-account-balance';
import { GetAccountBalanceResult } from '../models/get-account-balance-result';
import { getReloadAccountBalanceConfig } from '../fn/payments/get-reload-account-balance-config';
import { GetReloadAccountBalanceConfig$Params } from '../fn/payments/get-reload-account-balance-config';
import { GetReloadAccountBalanceConfigResult } from '../models/get-reload-account-balance-config-result';
import { postReloadAccountBalance } from '../fn/payments/post-reload-account-balance';
import { PostReloadAccountBalance$Params } from '../fn/payments/post-reload-account-balance';
import { ReloadAccountBalanceResult } from '../models/reload-account-balance-result';

@Injectable({ providedIn: 'root' })
export class ApiPaymentsService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPaymentsAccountBalance()` */
  static readonly GetPaymentsAccountBalancePath = '/Payments/account-balance';

  /**
   * get-payments-account-balance.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccountBalance()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccountBalance$Response(params?: GetAccountBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAccountBalanceResult>> {
    return getAccountBalance(this.http, this.rootUrl, params, context);
  }

  /**
   * get-payments-account-balance.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccountBalance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccountBalance(params?: GetAccountBalance$Params, context?: HttpContext): Observable<GetAccountBalanceResult> {
    return this.getAccountBalance$Response(params, context).pipe(map((r: StrictHttpResponse<GetAccountBalanceResult>): GetAccountBalanceResult => r.body));
  }

  /** Path part for operation `getPaymentsReloadAccountBalanceConfig()` */
  static readonly GetPaymentsReloadAccountBalanceConfigPath = '/Payments/reload-account-balance-config';

  /**
   * get-payments-reload-account-balance-config.
   *
   * Get Config Rechargement Solde<br>Get Config Rechargement Solde par site
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReloadAccountBalanceConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReloadAccountBalanceConfig$Response(
    params?: GetReloadAccountBalanceConfig$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<GetReloadAccountBalanceConfigResult>> {
    return getReloadAccountBalanceConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * get-payments-reload-account-balance-config.
   *
   * Get Config Rechargement Solde<br>Get Config Rechargement Solde par site
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReloadAccountBalanceConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReloadAccountBalanceConfig(params?: GetReloadAccountBalanceConfig$Params, context?: HttpContext): Observable<GetReloadAccountBalanceConfigResult> {
    return this.getReloadAccountBalanceConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetReloadAccountBalanceConfigResult>): GetReloadAccountBalanceConfigResult => r.body),
    );
  }

  /** Path part for operation `postPaymentsReloadAccountBalance()` */
  static readonly PostPaymentsReloadAccountBalancePath = '/Payments/reload-account-balance';

  /**
   * post-payments-reload-account-balance.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postReloadAccountBalance()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postReloadAccountBalance$Response(
    params?: PostReloadAccountBalance$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ReloadAccountBalanceResult>> {
    return postReloadAccountBalance(this.http, this.rootUrl, params, context);
  }

  /**
   * post-payments-reload-account-balance.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postReloadAccountBalance$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postReloadAccountBalance(params?: PostReloadAccountBalance$Params, context?: HttpContext): Observable<ReloadAccountBalanceResult> {
    return this.postReloadAccountBalance$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReloadAccountBalanceResult>): ReloadAccountBalanceResult => r.body),
    );
  }
}
